import Controller from "@ember/controller";
import { action } from "@ember/object";
import { service } from "@ember/service";

export default class CirclesNewController extends Controller {
  @service router;

  @action
  onAfterSave() {
    const { slug_path_with_id } = this.model;
    this.router.replaceWith("circle", slug_path_with_id);
  }
}
